import { render, staticRenderFns } from "./VisitaControlloEcgEditComponent.vue?vue&type=template&id=537a976c"
import script from "./VisitaControlloEcgEditComponent.vue?vue&type=script&lang=js"
export * from "./VisitaControlloEcgEditComponent.vue?vue&type=script&lang=js"
import style0 from "./VisitaControlloEcgEditComponent.vue?vue&type=style&index=0&id=537a976c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports